<section>
  <div class="form-register">
    <form [formGroup]="formDocumentSupportDetail">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
          <app-custom-input-text class="border-radius-right" [disabled]="true" [labelText]="'Artículo'"
            [value]="codeNameArticle" [required]="true">
          </app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-number ngDefaultControl formControlName="quantity" [labelText]="'Cantidad'"
            [required]="true" (onChangeNumber)="calculateTotalValue()"></app-custom-input-number>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6 form-label form-label">
          <app-custom-input-decimal [labelText]="'Vr.Unitario'" formControlName="unitValue" [required]="true"
            (onChangeNumber)="calculateTotalValue()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="totalValue" [labelText]="'Vr.Total'" [required]="true"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 col-12 d-flex">
          <div class="d-flex align-items-end mb-2 gap-2">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>